/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import { Typography } from "@material-ui/core";

export const SearchFilterTitle = ({ title }: any) => {
  return (
    <Typography
      variant="h3"
      style={{ marginBottom: "5px", fontWeight: "bold" }}>
      {title}
    </Typography>
  );
};
